import { Expose } from 'class-transformer';

export enum CompanyDocumentType {
  Offer = 'offer',
  Agreement = 'agreement',
}

export class CompanyDocumentModel {
  @Expose()
  name: string;

  @Expose()
  file: string;

  @Expose({ name: 'document_type' })
  documentType: CompanyDocumentType;
}
